module.exports = __webpack_public_path__ + "img/5.961fdf93.svg";